import React from "react";
import { Create, SimpleForm, TextInput } from "react-admin";

export const PlacementCreate = (props) => {
  return (
    <>
      <h1>New Placement Json</h1>
      <Create {...props} title="Create A New Cutoff Json">
        <SimpleForm title="New Placement Json">
          <TextInput source="institute_id" required fullWidth />
          <TextInput source="title" fullWidth />
          <TextInput source="description" fullWidth />
          <TextInput source="jsonData" required fullWidth multiline />
        </SimpleForm>
      </Create>
    </>
  );
};
